<template>
  <div :ref="name"></div>
</template>

<script>
  import E from 'wangeditor';

  export default {
    name: 'Editor',
    props: {
      name: {
        type: String,
        default: null
      },
      value: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        editor: null
      }
    },
    watch: {
      value: {
        handler(newValue, oldValue) {
          this.$nextTick(() => {
            this.initPage();
            if (newValue !== this.editor.txt.html()) {
              this.editor.txt.html(newValue);
            }
          });
        },
        immediate: true
      }
    },
    methods: {
      initPage() {
        let self = this;
        if (!this.editor) {
          this.editor = new E(this.$refs[this.name]);
          this.editor.config.onchange = newHtml => {
            this.$emit('input', newHtml);
          };
          this.editor.config.uploadImgServer = this.$uploadUrl;
          this.editor.config.uploadFileName = 'media';
          this.editor.config.uploadImgMaxSize = 5 * 1024 * 1024;
          this.editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png'];
          this.editor.config.uploadImgHooks = {
            before(xhr, editor, file) {

            },
            success(xhr) {

            },
            fail(xhr) {

            },
            error(xhr) {

            },
            timeout(xhr) {

            },
            customInsert(insertImgFn, result) {
              insertImgFn(result.media);
            }
          }
          this.editor.create();
        }
      }
    },
  }
</script>

<style lang="less" scoped>

</style>